import { Injectable } from "@angular/core";
import * as moment from "moment";
import { BehaviorSubject } from "rxjs";
import { Constants as localConstants } from '../constants' 


@Injectable({
    providedIn: 'root'
})
export class LocalDataService {
    public selectedCountryId: any = '';
    public selectedAgentStatus:any='';
    public selectedCountry: any = '';
    public selectedLanguage: any = '';
    public selectedScreen: string[] = [];
    public userToken: any = '';
    public shutdownReasonForAvaya: any = {};
    public noLoaderServices = ['callback-elevator-for-avaya','retrieve-call-details-elevator','insert-call-details', 'get-elevator-info'];
    ///Elevator Call Data
    public ecd: any = {};
    callAccept!: boolean;
    public componentReloadSubject = new BehaviorSubject<string>('');

    setLoginUserData(data: any) {
        localStorage.setItem('loginData', JSON.stringify(data));

        if (data.user.roleId != 3) {
            localStorage.setItem('spopLoginData', JSON.stringify(data.user));
          } else {
            //Clear all the CCC SPOP cookies
            if (localStorage.getItem("spopLoginData") != null) {
              localStorage.removeItem("spopLoginData")
            }
          }
    }
    clearLoginUserData() {
        localStorage.removeItem('loginData');
    }
    getAzureMapKey(): string {
        let aboutInfo = this.getLoginData('aboutInfo');
        if (aboutInfo != undefined || aboutInfo != null)
            return aboutInfo['azureMapKey'];
        return '';
    }
    getAboutInfo(): any {
        return this.getLoginData('aboutInfo');
    }
    getLoginUserData(): any {
        return this.getLoginData();
    }

    isAvayaUser() {
        let isCCCUser = this.isCCCLoginUser();
        if (isCCCUser == 2) {
            return true;
        }
        else {
            return false;
        }
    }
    getLoginUserType() {

        let type = localStorage.getItem('userType');
        let valueType;
        Object.keys(localConstants.USERTYPE)
            .forEach((key, value) => {
                if (key === type) {
                    valueType = value;
                }
            });
        return valueType;
    } 
    isCCCLoginUser() {
        let loginAccess = this.getLoginData();
        if (loginAccess || loginAccess != null) {
            if (loginAccess?.fromAvaya)
                return (loginAccess?.fromAvaya === 'yes') ? 2 : 1;

            else
                return loginAccess?.user?.settingsFor;
        }
        else
            return loginAccess?.user?.settingsFor;
    }
    getLanguageSkills(): any[] {
        return this.getLoginData('languageSkills');
    }
    getSelectedCountriesByDisplay(): any[] {
        let selectedCountries = this.getSelectedCountries();
        if (!selectedCountries)
            return [];
        return selectedCountries.filter((country: any) => country.display === 'd');
    }
    getSelectedLanguages(countryId: number): any[] {
        let selectedLanguages = this.getLoginData('selectedLanguages');
        if (!selectedLanguages)
            return [];
        return selectedLanguages.filter((language: any) => language.countryId === countryId);
    }    
    getSelectedCountriesByDisplayed(countryId: number): any[] {
        let selectedCountries = this.getSelectedCountries();
        if (!selectedCountries)
            return [];
        return selectedCountries.filter((country: any) => country.display === countryId);
    }
    
    getMenuList(): any[] {
        return this.getLoginData('menu');
    }
    getSelectedCountries(): any[] {
        return this.getLoginData('selectedCountries');
    }
    getEnableTPA() {
        let user = this.getLoginData('user');
        if (user && user.enableTPA)
            return user.enableTPA;
        return false;
    }

    getjasondata():any{
        return {
            "Idle": "Available",
            "reserved": "Reserved",
            "Busy": "Busy",
           "Offline": "Not Available",
            "Status": "Status"
        }
    }

    getAppConfig(): any {
        let config = this.getLoginData('config');
        if (config != undefined || config != null)
            return config['appConfig'];
            return {
            "idleSid": "WA5a6e1efde44e7d7356197e144b256a0a",
            "busySid": "WAf3a14b42f8b53ac05ebe8138c8136466",
            "deleteSid": "WA3ac9140bd1971a7bb584a65e43919fa1",
            "offlineSid": "WAdb8d448ce5a8bd0a968ca95435a7eeda",
            "reservSid": "WAcdef77ea571f4acc80cce783e5722300",
             isOnlyAudio: '', switchOffLogs: false
            };
            //INT
            // // "idleSid": "WA5a6e1efde44e7d7356197e144b256a0a",
            // // "busySid": "WAf3a14b42f8b53ac05ebe8138c8136466",
            // // "deleteSid": "WA3ac9140bd1971a7bb584a65e43919fa1",
            // // "offlineSid": "WAdb8d448ce5a8bd0a968ca95435a7eeda",
            // // "reservSid": "WAcdef77ea571f4acc80cce783e5722300",
            //dev
            // // "idleSid": "WA7942ac64425fe6d66cd07e3eec122a64",
            // // "busySid": "WAaf374be766ef12e9e76a0235a0eaa278",
            // // "deleteSid": "WA19d265807b3d5688c6a1fe9f77656e8f",
            // // "offlineSid": "WA4c7e36d428df09629362ea889273bee9",
            // // "reservSid": "WA9c2c3a6c63eef5274d0d31e3d423670b",
       
    }
    getLoginUserSId(): number {
        let user = this.getLoginData('user');
        if (user)
            return user['sId'];
        return 0;
    }
    getLoginUserCountryId(): number {
        let user = this.getLoginData('user');
        if (user)
            return user['countryId'];
        return 0;
    }
    getLoginUserName(): string {
        let user = this.getLoginData('user');
        if (user)
            return user['name'];
        return '';
    }
    getLoginUserRoleId(): number {
        let user = this.getLoginData('user');
        if (user)
            return user['roleId'];
        return 0;
    }
    getLoginUserId(): number {
        let user = this.getLoginData('user');
        if (user)
            return user['userID'];
        return 0;
    }
    getLanguageShortName(): string {
        let user = this.getLoginData('user');
        if (user)
            return user['languageShortName'];
        return '';
    }
    getLoginWorkerId(): number {
        let user = this.getLoginData('user');
        if (user)
            return user['workerId'];
        return 0;
    }
    getLoginWorkersId(): number {
        let user = this.getLoginData('user');
        if (user)
            return user['sId'];
        return 0;
    }

    //No data
    isAgent(): number {
      let user = this.getLoginData('user');
      if (user)
          return user['isAgent'];
      return 0;
    }
    getcallType(): string {
      let user = this.getLoginData('user');
      if (user)
          return user['callType'];
      return '';
    }
    getLoginData(key?: string) {
        let localLoginData = localStorage.getItem('loginData');
        let loginData = localLoginData ? JSON.parse(localLoginData) : undefined;
        if (loginData != undefined) {
            if (key)
                return loginData[key];
            else return loginData;
        }
        return null;
    }
    /*Router Auth guard check every menu url
    */
    getMenuUrls(key?: string) {
        let keyURL = key!.replace(/\//g, "");
        let localMenuURLSData = localStorage.getItem('Menu_URLS');
        let loginURLSData = localMenuURLSData ? JSON.parse(localMenuURLSData) : undefined;
        if (loginURLSData != undefined) {
            if (keyURL && keyURL.indexOf('login') > -1 || keyURL.indexOf('screenpop') > -1)
                return true;
            else if (loginURLSData.length > 0) {
                if (loginURLSData.includes(keyURL))
                    return true;
            }
        }
        return false;
    }
    // return the UTC date ranges for to fetch the Twilio reports
    public GetUTCRangeDate() {

        let fromDate = moment().format('YYYY-MM-DD') + ' ' + localConstants.REPORTTIMEDATE.StartTime;
        let toDate = moment().format('YYYY-MM-DD') + ' ' + localConstants.REPORTTIMEDATE.EndTime;
        fromDate = moment(fromDate).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        toDate = moment(toDate).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        return { fromDate: fromDate, toDate: toDate };
    };
    // return the custom UTC date ranges to fetch the search reports
    public GetCustomUTCDate(startDate: string, endDate: string, formatString?: string | null | undefined) {
        if (formatString === null || formatString === undefined) {
            formatString = ('YYYY-MM-DD HH:mm:ss');        }

        let fromDate = moment(startDate + ' ' + localConstants.REPORTTIMEDATE.StartTime).utc().format(formatString);
        let toDate = moment(endDate + ' ' + localConstants.REPORTTIMEDATE.EndTime).utc().format(formatString);
        return { fromDate: fromDate, toDate: toDate };
    }
    // return the subtract UTC date  
    public SubstractDate(number: number) {
        let localDate = moment().format('YYYY-MM-DD') + ' ' + localConstants.REPORTTIMEDATE.StartTime;
        let UTCdate = moment.utc(moment(localDate));
        return moment(UTCdate).subtract(number, "days").format('YYYY-MM-DD');
    };
    // return the local current time and date with default format
    public GetTodayDateTime(formatString: any) {
        if (formatString === null || formatString === undefined) {
            formatString = 'YYYY-MM-DD HH:mm:ss';
        }
        return moment().format(formatString);
    };
    getTodayDateTime(formatString?: any) {
        if (formatString === null || formatString === undefined) {
          formatString = 'YYYY-MM-DD HH:mm:ss';
        }
        return moment().format(formatString);
      };

      roleBaseUrlAccess(result: any) {
        let delimitersArray = ['#', '$', ''];
        let urlArray: any[] = [];
    
        result.menu.forEach((obj: any) => {
          if (obj.menu != undefined || obj.menu != null) {
            obj.menu.forEach((submenu: any) => {
              if (submenu.menu != undefined || submenu.menu != null) {
                submenu.menu.forEach((nestedsubmenu: any) => {
                  if (!delimitersArray.includes(nestedsubmenu.link))
                    urlArray.push(nestedsubmenu.link)
                });
              }
              if (!delimitersArray.includes(submenu.link))
                urlArray.push(submenu.link)
            });
          }
          if (!delimitersArray.includes(obj.link))
            urlArray.push(obj.link)
        });
        // Append change password menu
        urlArray.push('change-pwd')
        localStorage.setItem('Menu_URLS', JSON.stringify(urlArray));
      }

      getSpopCurrentUser() {
        try {
          return JSON.parse(localStorage.getItem("spopLoginData")!);
        } catch (e) {
          return null;
        }
      }
      localstorageSet(key: string, value: any) {
        return localStorage.setItem(key, value);
      }
    
      localstorageGet(key: string) {
        return localStorage.getItem(key);
      }
    
      localstorageRemove(key: string) {
        return localStorage.removeItem(key);
      }

}
